<script lang="ts">
	import videoSource from "@assets/videos/hero.mp4?url";
	import BuyCampfireLink from "@components/BuyCampfireLink.svelte";
	import Checkmark from "@components/Checkmark.svelte";
	import Media from "@components/common/Media.svelte";
	import flame from "@core/assets/icons/flame.svg";

	const features = ["Ohniště i v místě, kde to jinak nejde", "Vyrobeno ZE žáruvzdorné oceli", "Nezanechá spálenou zem"];

	let videoElement = $state<HTMLVideoElement>();
</script>

<section class="relative full-width p-0">
	<video
		bind:this={videoElement}
		src={videoSource}
		autoplay
		playsinline
		loop
		muted
		class="absolute inset-x-0 -inset-y-36 h-[calc(100%+9rem)] object-cover w-full z-[-1]"
	>
		Váš prohlížeč nepodporuje přehrávání videí.
	</video>
	<div class="xs:my-0 -my-16 grid-container">
		<div class="container-10 2xl:container-8">
			<h1
				class="text-10/12 sm:text-17/19 md:text-18/20 lg:text-19/21 xl:text-20/22 px-8 pt-4 md:pt-0 md:px-11.5 text-center font-bold mb-6 text-nov-light-000"
			>
				Rozdělej si <span class="whitespace-nowrap"
					><Media
						width={24}
						height={24}
						source={{ src: flame, type: "image/svg+xml" }}
						alt="🔥"
						class="size-[1em] !inline-block -translate-y-[0.125em]"
					/>oheň</span
				> kdekoliv!
			</h1>
			<ul class="flex flex-col 2xl:flex-row items-center justify-center gap-2 text-nov-dark-900">
				{#each features as f (f)}
					<li
						class="bg-white/95 tracking-[0.005em] uppercase text-3/4 md:text-3/6.5 backdrop-blur-lg font-normal rounded-2xl lg:rounded-3xl px-4 py-2"
					>
						<span class="text-xs"><Checkmark class="inline" /></span>
						<span>{f}</span>
					</li>
				{/each}
			</ul>
			<p class="mt-5 text-center text-title3 sm:text-8/10 font-bold text-nov-light-000">
				Naše přenosné ohniště složíš za minutu<br /> a zpomalíš na celý večer
			</p>
		</div>
		<BuyCampfireLink class="mx-auto mt-10 mb-24" />
	</div>
</section>
